import React, { useState } from 'react'
import { Panel } from 'rsuite'
import ViewFormWidget from '../../projectProposal/dynamicForm/ViewFormWidget'
export default function SubProjectAddressView({
  schema,
  shaded,
  bordered,
  collapsible,
  defaultExpanded,
  ...props
}) {
  return (
    <>
      {schema && (
        <Panel
          header={schema.header}
          shaded={shaded}
          bordered={bordered}
          collapsible={collapsible}
          defaultExpanded={defaultExpanded}
          style={{ marginTop: 10 }}
        >
          <div style={{ marginTop: -20 }}>
            {schema.sameAddress && schema.sameAddress.value != '0' ? (
              <b>{schema.sameAddress.valueDef}</b>
            ) : (
              <ViewFormWidget schema={schema} />
            )}
          </div>
        </Panel>
      )}
    </>
  )
}
